import { formatName } from '../lib/format';
import Button from './ui/Button';
import React, { useEffect } from "react";
import { auth, db } from "../firebase-config";
import Logo from '../assets/Logo.png';
import { onAuthStateChanged } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { setActiveOrg, setActiveOrgInfo, setUid, setUser } from "../redux/userReducer";
import { useDispatch, useSelector } from "react-redux";
import { doc, getDoc } from "firebase/firestore";
import { postWithAuth } from "../common";
import { toast } from "react-toastify";
import useResponsiveTables from "../hooks/useResponsiveTables";
import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const Header = ({ triggerRefetch, setTriggerRefetch }) => {


    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const uid = useSelector((state) => state.user.uid)
    const activeOrg = useSelector((state) => state.user.activeOrg)
    const userInfo = useSelector((state) => state.user.user)
    const activeOrgInfo = useSelector((state) => state.user.activeOrgInfo)

    useResponsiveTables();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/login')
            } else {
                dispatch(setUid(user.uid))
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (activeOrg && activeOrg.role === 'worker') {
            const isAllowedWorkerRoute = location.pathname === '/workers' || location.pathname.startsWith('/worker/')
            if (!isAllowedWorkerRoute) {
                navigate('/worker/overview', { replace: true })
            }
        }
        // A client contact has Site Hub and nothing else. The server refuses them
        // everywhere else anyway; this just stops them landing on a page that errors.
        if (activeOrg && activeOrg.role === 'client' && location.pathname !== '/site-management') {
            navigate('/site-management', { replace: true })
        }
        // A 'user' login is the sales team: Client Hub only, as the sidebar shows.
        if (activeOrg && activeOrg.role === 'user' && location.pathname !== '/client-hub') {
            navigate('/client-hub', { replace: true })
        }
    }, [activeOrg, location.pathname, navigate])

    useEffect(() => {
        if (uid) {
            getUserInfo(uid)
        }
    }, [uid])


    useEffect(() => {
        if (userInfo && !activeOrg) {
            restoreOrg()
        }
    }, [userInfo, activeOrg])


    const restoreOrg = async () => {
        // const existingOrg = window.localStorage.getItem('precinct-comply-activeOrg')
        // if (existingOrg) {
        //     dispatch(setActiveOrg(JSON.parse(existingOrg)))
        // } else {
        dispatch(setActiveOrg(userInfo.organisations[0]))
        // }
    }

    useEffect(() => {
        // Clients may not read the organisation record (it holds company settings);
        // Site Hub sets its name and logo from what the server sends them instead.
        if (activeOrg && activeOrg.role !== 'client') {
            fetchOrgInfo(activeOrg.id)
        }
    }, [activeOrg])


    // useEffect(() => {
    //     if (activeOrg) {
    //         // fetchVenues(activeOrg.id)
    //         // fetchCategories(activeOrg.id)
    //         // fetchActions(activeOrg.id)
    //         // fetchOrgInfo(activeOrg.id)
    //         if (userInfo && userInfo.isSuperAdmin) {
    //             // Fetch orgs again.
    //             getUserInfo(userInfo.id)
    //         }
    //         setTriggerRefetch && setTriggerRefetch(false)
    //     }
    // }, [activeOrg, triggerRefetch])


    const fetchOrgInfo = async (uid) => {
        const orgData = ((await getDoc(doc(db, 'organisations', uid))).data())
        dispatch(setActiveOrgInfo({ ...orgData, id: uid }))
    }

    const getUserInfo = async (uid) => {
        let userData = ((await getDoc(doc(db, 'users', uid))).data())

        // User in workers table?
        if (!userData) {
            userData = ((await getDoc(doc(db, 'workers', uid))).data())
            if (userData) {
                // Add organisation to worker.
                userData = { ...userData, organisations: [{ id: userData.orgId, role: 'worker' }] }
            }
        }

        // Signed in, but no user or worker record: nothing can load, so sign out
        // instead of leaving a blank page with no way out.
        if (!userData) {
            toast.error('Account not found')
            setTimeout(() => {
                signOutUser()
            }, 2000)
            return
        }

        if (userData.status === 'Inactive') {
            toast.error('Your account is deactivated.')
            setTimeout(() => {
                signOutUser()
            }, 2000)
            return
        }

        if (userData.isSuperAdmin) {
            // Add all orgs to users orgs.
            try {

                const recordsData = await postWithAuth('organisations', {})
                const records = recordsData?.data || []

                dispatch(setUser({ ...userData, organisations: records.map(r => ({ id: r.id, role: 'admin' })), id: uid }))
            } catch (e) {
                toast.error(e.message)
            }
        } else {
            dispatch(setUser({ ...userData, id: uid }))
        }
    }

    const signOutUser = async () => {
        await auth.signOut();
        window.location.reload()
    }

    if (!activeOrg || !activeOrg.role) {
        return
    }

    if (activeOrg.role === 'admin' || activeOrg.role === 'worker' || activeOrg.role === 'client') {
        return null
    }

    return (<div className="header" style={{ padding: '12px 16px 0', display: 'flex', alignItems: 'center', width: '100%', boxSizing: 'border-box', justifyContent: 'space-between' }}>
        <div style={{ width: '100%', background: '#ffffff', border: '1px solid #dbe3ef', borderRadius: '28px', boxShadow: '0 16px 40px rgba(15, 23, 42, 0.08)', padding: '16px 22px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', minWidth: 0 }}>
            <img src={Logo} alt="Managd" className="logo" style={{ width: '170px', maxWidth: '40vw' }} />
            <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: '12px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{activeOrgInfo?.name || 'Organisation'}</div>
                <h3 style={{ margin: '4px 0 0', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Welcome, {formatName(userInfo?.firstName)}</h3>
            </div>
        </div>
        <Button variant="secondary" size="md" className="hide-mobile hide-print" style={{marginTop: 0}} onClick={signOutUser}>Sign out</Button>
        </div>
    </div>)
}

export default Header
